const END_TOLERANCE = 1;

export const getConnectionArrowVisibility = ({ scrollLeft, clientWidth, scrollWidth }) => {
  const maximumScroll = Math.max(0, scrollWidth - clientWidth);

  return {
    hideLeft: scrollLeft <= END_TOLERANCE,
    hideRight: maximumScroll <= END_TOLERANCE
      || scrollLeft >= maximumScroll - END_TOLERANCE,
  };
};
